import React from "react";
import { Card, CardBody } from "reactstrap";

const HealthCard = ({ label, value, defaultValue, subLabel }) => (
  <Card className="mb-3 shadow-sm border border-secondary">
    <CardBody className="py-3">
      <div
        className="overflow-auto"
      >
        <strong>{label}: </strong>
        <div className="text-muted mt-2">{value ?? defaultValue}</div>
      </div>
      {subLabel && (
        <div className="text-muted small mt-2">⏱ {subLabel}</div>
      )}
    </CardBody>
  </Card>
);

export default HealthCard;
